import { RE_ASSESSMENT_FILTER } from "../../../enums/ReAssessmentEnums";
import { parseListInput } from "../../../core/utils/parse-list-input";
import { FILTER_GROUPS, STUDY_STATUS_OPTIONS, STUDY_TYPE_OPTIONS, yesNo } from "../../quick-filter/ExtraFilters";

/**
 * Rapor grid'inin "Diğer filtreler" alanları — çubukta kendi düğmesi olmayan, sol panelde (ReportFilter) duran
 * filtreler. Alan tanımının biçimi: bkz. quick-filter/ExtraFilters. Sıra paneldeki sıradır; gruplar (FILTER_GROUPS)
 * ilk alanlarının sırasıyla dizildiği için aynı gruptakiler yan yana tutulur.
 */
export const REPORT_EXTRA_FIELDS = [
    { key: 'patientId', group: FILTER_GROUPS.PATIENT, label: 'Patient Id', kind: 'text', empty: undefined },
    { key: 'patientName', group: FILTER_GROUPS.PATIENT, label: 'Patient Name', kind: 'text', empty: undefined },
    { key: 'accessionNumber', group: FILTER_GROUPS.PATIENT, label: 'Accession No', kind: 'text', empty: undefined },
    {
        key: 'studyIdList', group: FILTER_GROUPS.PATIENT,
        label: 'Study ID',
        kind: 'list',
        empty: [],
        // Sol panel gibi: sayı olmayan değer atılır (bkz. ReportFilter.filter).
        toFilter: (value) => ({
            studyIdList: parseListInput(value).map(x => parseInt(x, 10)).filter(x => !isNaN(x)),
        }),
    },
    { key: 'studyInstanceUidList', group: FILTER_GROUPS.PATIENT, label: 'Study UID', kind: 'list', empty: [] },
    { key: 'hospitalGroupIdList', group: FILTER_GROUPS.SCOPE, label: 'Hospital Groups', kind: 'lookup', source: 'hospitalGroups', empty: [], permissions: ['HOSPITAL_GROUP_FILTER'] },
    { key: 'hospitalIdList', group: FILTER_GROUPS.SCOPE, label: 'Hospital Name', kind: 'lookup', source: 'hospitals', empty: [] },
    { key: 'institutions', group: FILTER_GROUPS.SCOPE, label: 'Institution', kind: 'lookup', source: 'institutions', empty: [], permissions: ['VIEW_STUDY_INSTITUTION'] },
    { key: 'studyTypeList', group: FILTER_GROUPS.WORK, label: 'Study Type', kind: 'select', multiple: true, options: STUDY_TYPE_OPTIONS, empty: [] },
    { key: 'studyStatus', group: FILTER_GROUPS.WORK, label: 'Study Status', kind: 'select', multiple: true, options: STUDY_STATUS_OPTIONS, empty: [] },
    {
        // Kapsam SUNUCUDA belirlenir: RE_ASSESSMENT_MANAGE yoksa yalnız kullanıcının kendi okuduğu raporlar.
        key: 'reAssessmentState', group: FILTER_GROUPS.WORK,
        label: (can) => (can('RE_ASSESSMENT_MANAGE') ? 'Re-Assessment' : 'My Re-Assessments'),
        kind: 'select',
        options: [
            { value: RE_ASSESSMENT_FILTER.CHANGED, label: 'Report Changed' },
            { value: RE_ASSESSMENT_FILTER.UNCHANGED, label: 'Report Unchanged' },
            { value: RE_ASSESSMENT_FILTER.ANY, label: 'Re-Assessed' },
        ],
        empty: undefined,
    },
    // Sol panel gibi yalnız "Bana atananlar" (kullanıcı listesinden seçim rapor panelinde yok).
    { key: 'assignDoctor', group: FILTER_GROUPS.PEOPLE, label: 'Assigned (Doctor)', kind: 'assign', empty: null, permissions: ['STUDY_SET_READ'] },
    { key: 'assignReporter', group: FILTER_GROUPS.PEOPLE, label: 'Assigned (Reporter)', kind: 'assign', empty: null, permissions: ['REPORT_ADD_OR_EDIT'] },
    { key: 'readUserId', group: FILTER_GROUPS.PEOPLE, label: 'Read User', kind: 'user', source: 'readableUsers', userType: 'read', empty: undefined },
    { key: 'writeUserId', group: FILTER_GROUPS.PEOPLE, label: 'Wrote User', kind: 'user', source: 'writableUsers', userType: 'write', empty: undefined },
    { key: 'isDeleted', group: FILTER_GROUPS.OTHER, label: 'Is Deleted', kind: 'select', options: yesNo('Deleted', 'Not Deleted'), empty: false, allOption: true, permissions: ['STUDY_REQUEST_LIST_DELETED'] },
];
